import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ButtonGroupTextColorsConstantType,
    ButtonGroupTextDynamicStyleType,
    ButtonGroupTextColors
} from "./type";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import type {
    Mutable
} from "../../../../types";
import {
    getAttachedGroupItemStyle
} from "../../../attachedGroup/stylesheet";

export const getButtonGroupTextColors = ({
    isDisabled,
    variant,
    colors,
    type
}: ButtonGroupTextColorsConstantType): ButtonGroupTextColors => {
    if(isDisabled) {
        const disabledColors = getTypeColors({
            isDisabled: true,
            variant: "tonal",
            type: "neutral",
            colors
        });

        return {
            ...disabledColors,
            containerColor: colors.content.container.mid,
            borderColor: getTypeColors({
                variant: "outline",
                isDisabled: true,
                type: "neutral",
                colors
            }).borderColor
        };
    }

    if(variant === "tonal") {
        return getTypeColors({
            variant: "tonal",
            colors,
            type
        });
    }

    return {
        ...getTypeColors({
            variant: "outline",
            colors,
            type
        }),
        containerColor: colors.content.container.mid,
        titleColor: colors.content.text.mid,
        iconColor: colors.content.icon.mid
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "row",
        borderStyle: "solid",
        alignItems: "center"
    },
    title: {
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    controlPaddings,
    currentColors,
    shapeConfigs,
    currentSize,
    isDisabled,
    groupItem,
    borders,
    spaces
}: ButtonGroupTextDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: currentColors.containerColor,
            paddingHorizontal: controlPaddings.small,
            borderColor: currentColors.borderColor,
            minHeight: currentSize.minHeight,
            borderWidth: borders.line,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(groupItem) {
        const attachedStyle = getAttachedGroupItemStyle({
            innerRadius: groupItem.innerRadius,
            outerRadius: groupItem.outerRadius,
            orientation: groupItem.orientation,
            isOverlap: groupItem.isOverlap,
            position: groupItem.position,
            isFocused: false,
            isActive: false,
            shapeConfigs,
            isDisabled,
            borders
        });

        Object.assign(styles.container, attachedStyle.container, attachedStyle.surface);
    }

    return styles;
};
export default stylesheet;
